/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="94.27" height="95.58" viewBox="0 0 94.27 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="bd7f3dfc-aed1-424a-ae60-97fb7d6664fa" x="0" y="0" width="94.27" height="95.58" maskUnits="userSpaceOnUse">
      <g transform="translate(-30 -29.5)">
        <polygon points="30 125.08 124.27 125.08 124.27 29.5 30 29.5 30 125.08" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <path d="M62.08,53.91V56.6l-.42.07-.42.09a6.43,6.43,0,0,0-4.85,3.94,7.92,7.92,0,0,0-.56,3.67,6.3,6.3,0,0,0,3.37,5.36A28.49,28.49,0,0,0,62,71c1.18.5,2.38,1,3.56,1.46a2.15,2.15,0,0,1,1.35,2.35A2.35,2.35,0,0,1,65,77.15a7.39,7.39,0,0,1-1.49.16,3.71,3.71,0,0,1-3.79-2.77c-.11-.33-.19-.67-.29-1L55,74.67a9.34,9.34,0,0,0,2.17,4.46,7.59,7.59,0,0,0,4.94,2.27v3.48H65V81.44c.59-.12,1.16-.21,1.71-.36a6.69,6.69,0,0,0,4.74-3.84,7.91,7.91,0,0,0,.55-4.7,6.22,6.22,0,0,0-3.15-4.47,36.5,36.5,0,0,0-4.31-1.88c-.89-.35-1.75-.76-2.6-1.18a1.9,1.9,0,0,1-1-1.17,2.63,2.63,0,0,1,1.84-3.31,3.07,3.07,0,0,1,3,.78A5.94,5.94,0,0,1,67,63.17c.1.22.19.44.29.68l4-1.67a8.25,8.25,0,0,0-1.49-3A7.1,7.1,0,0,0,65,56.6V53.91Z" transform="translate(-30 -29.5)" fill="#ffb81c" fillRule="evenodd"/>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M95.94,41.87H31.25A1.25,1.25,0,0,0,30,43.12v80.71a1.25,1.25,0,0,0,1.25,1.25H95.94a1.24,1.24,0,0,0,1.25-1.25V43.12A1.24,1.24,0,0,0,95.94,41.87Zm-1.25,2.5v78.21H32.5V44.37Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M81.92,94.41A1.25,1.25,0,0,1,82,96.9H45.14a1.25,1.25,0,0,1-1.25-1.25A1.27,1.27,0,0,1,45,94.41h36.9Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M81.92,106.62a1.25,1.25,0,0,1,.12,2.49H45.14a1.25,1.25,0,0,1-1.25-1.25A1.27,1.27,0,0,1,45,106.62h36.9Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M58.61,29.5h.13l64.4,6.2a1.25,1.25,0,0,1,1.13,1.23v.13l-7.73,80.34a1.25,1.25,0,0,1-1.24,1.13h-.13l-19.32-1.86a1.25,1.25,0,0,1,.12-2.5h.12l18.08,1.74,7.49-77.86-61.91-6L58.67,43.25a1.24,1.24,0,0,1-1.23,1.13h-.13a1.25,1.25,0,0,1-1.13-1.24V43l1.2-12.38A1.25,1.25,0,0,1,58.61,29.5Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M96.09,85.92l8,.77a1.26,1.26,0,0,1,1.13,1.37A1.25,1.25,0,0,1,104,89.19h-.13l-8-.77a1.25,1.25,0,0,1,.11-2.5Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M96.09,98.19l6.87.66a1.25,1.25,0,0,1-.11,2.49h-.13l-6.87-.66a1.25,1.25,0,0,1,.11-2.5Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M96.09,73.65l9.21.89a1.25,1.25,0,0,1,1.13,1.36A1.24,1.24,0,0,1,105.19,77h-.13l-9.21-.89A1.25,1.25,0,0,1,96,73.65Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M96.08,61.38l10.4,1a1.25,1.25,0,0,1-.12,2.5h-.12l-10.4-1a1.25,1.25,0,0,1,.11-2.5Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
      <g mask="url(#bd7f3dfc-aed1-424a-ae60-97fb7d6664fa)">
        <path d="M96,49.11h.13l11.56,1.12a1.25,1.25,0,0,1-.12,2.49h-.12L95.85,51.6A1.25,1.25,0,0,1,96,49.11Z" transform="translate(-30 -29.5)" fill="#0e497b"/>
      </g>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'TwoPapersWithDollarSignIcon';

export default Icon;
